import type {
  CompanyEntity,
  LegalEntityMap,
  PersonEntity,
} from '@festina/legalentity-general-types/legalentity'
import { createRequiredAndOptionalContext } from '@festina-life/ui/libs'

type IdMapperContextType = {
  getPersonEntity: (internalId: string) => PersonEntity
  getCompanyEntity: (internalId: string) => CompanyEntity
  getIdentification: (internalId: string) => LegalEntityMap
}

const [useIdMapperContext, useOptionalIdMapperContext, Provider] =
  createRequiredAndOptionalContext<IdMapperContextType>('IdMapper')

export {
  type IdMapperContextType,
  Provider,
  useIdMapperContext,
  useOptionalIdMapperContext,
}
